// WIN36 product page:
// 1. No size preselected: Dawn picks the first variant, so we uncheck the size until the shopper picks one,
//    and block add-to-cart (main button and sticky bar) with an error until then.
// 2. Button label reflects the size and price: "Reserve size 10.5 — $250".
// 3. Mobile sticky add-to-cart that mirrors Dawn's main button.
(() => {
  const configEl = document.querySelector('[data-w36-product-config]');
  if (!configEl) return;
  const cfg = JSON.parse(configEl.textContent);
  const root = document.querySelector(`product-info[data-section="${cfg.sectionId}"]`);
  const form = document.getElementById(cfg.formId);
  if (!root || !form) return;

  const button = () => document.getElementById(`ProductSubmitButton-${cfg.sectionId}`);
  const sizeFieldset = () => root.querySelectorAll('variant-selects fieldset')[cfg.sizeIndex];
  const checkedSize = () => sizeFieldset()?.querySelector('input:checked')?.value;

  let sizeChosen = !cfg.requireSize || new URLSearchParams(window.location.search).has('variant');

  if (!sizeChosen) {
    sizeFieldset()?.querySelectorAll('input[type="radio"]').forEach((input) => (input.checked = false));
  }

  // Size picked: Dawn re-renders the picker with the chosen variant
  root.addEventListener('change', (event) => {
    if (sizeFieldset()?.contains(event.target)) {
      sizeChosen = true;
      showError(false);
      update();
    }
  });

  // Runs before Dawn's product-form handler (capture on document)
  document.addEventListener(
    'submit',
    (event) => {
      if (event.target !== form || sizeChosen) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(true);
      sizeFieldset()?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );

  function showError(on) {
    const fieldset = sizeFieldset();
    if (!fieldset) return;
    fieldset.classList.toggle('w36-size-error', on);
    let message = root.querySelector('[data-w36-size-error]');
    if (on && !message) {
      message = document.createElement('p');
      message.className = 'w36-size-error__text';
      message.setAttribute('role', 'alert');
      message.dataset.w36SizeError = '';
      message.textContent = cfg.sizeError;
      fieldset.closest('variant-selects').after(message);
    }
    if (!on) message?.remove();
  }

  function price() {
    const box = root.querySelector(`#price-${cfg.sectionId}`);
    const item = box?.querySelector('.price--on-sale .price-item--sale') || box?.querySelector('.price-item--regular');
    return item ? item.textContent.trim() : '';
  }

  function update() {
    const size = sizeChosen ? checkedSize() : null;

    // "Shoe Size · 10.5"
    const legend = sizeFieldset()?.querySelector('legend');
    if (legend) {
      let value = legend.querySelector('.w36-legend-value');
      if (size && !value) {
        value = document.createElement('span');
        value.className = 'w36-legend-value';
        legend.append(value);
      }
      if (value) {
        const text = size ? ` · ${size}` : '';
        if (value.textContent !== text) value.textContent = text;
      }
    }

    // Button label (left alone when sold out / unavailable)
    const btn = button();
    const label = btn?.querySelector('span');
    const template = size ? cfg.labelSelected : cfg.labelUnselected;
    if (!label || btn.disabled || !template) return;
    const text = template.replace('[size]', size || '').replace('[price]', price()).trim();
    if (label.textContent.trim() !== text) label.textContent = text;
  }

  let queued = false;
  new MutationObserver((mutations) => {
    if (mutations.every((m) => m.target.closest?.('[data-w36-sticky-atc]') || m.target.parentElement?.closest('[data-w36-sticky-atc]'))) return;
    if (queued) return;
    queued = true;
    setTimeout(() => {
      queued = false;
      update();
    }, 0);
  }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  update();

  // Mobile sticky add-to-cart
  const bar = document.querySelector('[data-w36-sticky-atc]');
  const main = button();
  if (!bar || !main) return;
  const stickyButton = bar.querySelector('button');
  const stickyLabel = bar.querySelector('[data-w36-sticky-label]');
  const footer = document.querySelector('.shopify-section-group-footer-group');
  // Only write when something changed: the bar lives inside product-info, so writes would retrigger observers
  const sync = () => {
    const current = button();
    if (!current) return;
    const text = current.querySelector('span')?.textContent.trim() || current.textContent.trim();
    if (stickyLabel.textContent !== text) stickyLabel.textContent = text;
    if (stickyButton.disabled !== current.disabled) stickyButton.disabled = current.disabled;
  };
  let mainVisible = true;
  let footerVisible = false;
  const toggle = () => {
    bar.hidden = mainVisible || footerVisible;
  };
  new IntersectionObserver(([entry]) => {
    mainVisible = entry.isIntersecting;
    sync();
    toggle();
  }).observe(main);
  if (footer) {
    new IntersectionObserver(([entry]) => {
      footerVisible = entry.isIntersecting;
      toggle();
    }).observe(footer);
  }
  new MutationObserver(sync).observe(main, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  sync();
})();
